export const getClientQuote = (type: string, data: any) => {
  switch (type) {
    case 'whyReview':
    case 'partner-details':
      return data.quote

    default:
      return data.client_review
  }
}
export const getClientName = (type: string, data: any) => {
  switch (type) {
    case 'whyReview':
    case 'partner-details':
      return data.customer_name

    default:
      return data.client_name
  }
}

export const getClientDesignation = (type: string, data: any) => {
  switch (type) {
    case 'whyReview':
    case 'marketingReview':
    case 'partner-details':
      return data.company

    default:
      return
  }
}

export const getClientIcon = (type: string, data: any) => {
  switch (type) {
    case 'whyReview':
    case 'partner-details':
      return data.customer_image.url

    default:
      return data.image.url
  }
}
